/*
 * Flèches de navigation de la galerie produit, sur ordinateur uniquement.
 *
 * En disposition « vignettes », Dawn masque toutes les photos sauf l'active et
 * ne laisse que les vignettes pour changer d'image. Ses propres flèches ne
 * pilotent que le carrousel mobile, qui repose sur le défilement horizontal :
 * inutilisables ici. On ajoute donc des flèches qui déclenchent simplement la
 * vignette précédente ou suivante — aucune dépendance au fonctionnement interne
 * de la galerie, juste un clic sur un bouton déjà présent dans la page.
 */
(function () {
  var CARET =
    '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M9 1L5 5L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function build(gallery) {
    if (gallery.dataset.alevaNav === 'true') return;

    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    var thumbs = gallery.querySelectorAll('.thumbnail-list__item .thumbnail');
    if (!viewer || thumbs.length < 2) return;

    gallery.dataset.alevaNav = 'true';
    viewer.classList.add('aleva-gallery-viewer');

    var nav = document.createElement('div');
    nav.className = 'aleva-gallery-nav';

    ['prev', 'next'].forEach(function (dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'aleva-gallery-nav__button aleva-gallery-nav__button--' + dir;
      button.innerHTML = CARET;
      button.setAttribute('aria-label', dir === 'prev' ? 'Photo précédente' : 'Photo suivante');
      button.addEventListener('click', function () {
        move(gallery, dir === 'next' ? 1 : -1);
      });
      nav.appendChild(button);
    });

    viewer.appendChild(nav);
  }

  function move(gallery, step) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
    if (thumbs.length < 2) return;

    var current = thumbs.findIndex(function (thumb) {
      return thumb.getAttribute('aria-current') === 'true';
    });
    if (current === -1) current = 0;

    var next = (current + step + thumbs.length) % thumbs.length;
    thumbs[next].click();
  }

  function init() {
    document.querySelectorAll('media-gallery[data-desktop-layout="thumbnail"]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // La galerie est reconstruite quand une variante change d'image.
  document.addEventListener('shopify:section:load', init);
})();
